import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
const _IconHospitalityDiamond = (props) => {
    const { size, ...rest } = props;
    return size === '24' ? (React.createElement(Icon, { svg: React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M7.397 3.304A.75.75 0 0 1 8 3h8a.75.75 0 0 1 .603.304l4.25 5.75a.75.75 0 0 1-.008.903l-8.25 10.75a.75.75 0 0 1-1.19 0l-8.25-10.75a.75.75 0 0 1-.008-.903zM8.378 4.5 5.237 8.75h3.222L9.876 4.5zm3.08 0L10.04 8.75h3.918L12.543 4.5zM12 17.46l-2.012-7.21h4.024zm3.57-7.21-1.806 6.47 4.965-6.47zM14.123 4.5l1.417 4.25h3.222l-3.14-4.25zm-3.888 12.22L8.43 10.25H5.27z", fill: "currentColor" })), height: "24", width: "24", ...rest })) : null;
};
const defaultProps = {
    size: '24',
};
export const IconHospitalityDiamond = styled(_IconHospitalityDiamond) ``;
IconHospitalityDiamond.defaultProps = defaultProps;
//# sourceMappingURL=IconHospitalityDiamond.js.map